import styled from 'styled-components';
import { mediaTemplates } from 'theme/variables';

export const MoreInfoLinkStyled = styled.div`
  margin-top: 15px;
  ${mediaTemplates.xs} {
    margin-top: 5px;
  }
`;
